import { cards } from '@/mocks/homeMangaData';

const cardImages = [
  'https://readdy.ai/api/search-image?query=Beautiful%20Korean%20webtoon%20style%20villainess%20character%20in%20elegant%20gothic%20dress%20dramatic%20lighting%20rich%20jewel%20tones%20ornate%20palace%20background%20detailed%20illustration%20editorial%20quality%20artistic%20composition&width=800&height=600&seq=card-villainess&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Gentle%20fantasy%20illustration%20of%20an%20elven%20mage%20in%20a%20peaceful%20meadow%20journey%20theme%20warm%20golden%20hour%20lighting%20soft%20watercolor%20style%20serene%20atmosphere%20editorial%20composition%20with%20natural%20beauty&width=800&height=600&seq=card-frieren&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Epic%20Chinese%20xianxia%20fantasy%20illustration%20young%20cultivator%20ascending%20with%20starlight%20energy%20cosmic%20background%20traditional%20ink%20elements%20blended%20with%20modern%20digital%20art%20golden%20and%20emerald%20tones%20majestic%20composition&width=800&height=600&seq=card-xingchen&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Whimsical%20fantasy%20illustration%20of%20a%20noble%20young%20man%20in%20lavish%20mansion%20library%20setting%20mischievous%20expression%20warm%20candlelight%20atmosphere%20renaissance-inspired%20decor%20editorial%20quality%20with%20soft%20warm%20color%20palette&width=800&height=600&seq=card-count&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Elegant%20fairy%20tale%20illustration%20of%20a%20princess%20in%20ornate%20gown%20standing%20in%20moonlit%20castle%20garden%20dreamy%20romantic%20atmosphere%20soft%20pink%20and%20ivory%20tones%20delicate%20details%20editorial%20composition%20with%20magical%20ambiance&width=800&height=600&seq=card-princess&orientation=landscape',
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">精选推荐</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">编辑团队每日精选的高质量漫画推荐，帮你发现下一部心头好</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-4">
          {cards.map((item, i) => (
            <div key={i} className="bg-background-100 rounded-xl overflow-hidden group cursor-pointer hover:bg-background-200/70 transition-colors">
              <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src={cardImages[i]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 text-xs px-2 py-1 rounded-full bg-primary-500/90 text-background-50 font-medium">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2 leading-snug">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-3">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}